// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getIconPath } from '@tcp/core/src/utils/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { COUPON_REDEMPTION_TYPE } from '../../../../../../services/abstractors/CnC/CartItemTile';
import BodyCopy from '../../../../atoms/BodyCopy';
import Image from '../../../../atoms/Image';
import styles from '../../styles/CouponHeader.style';
import { isMobileWeb } from '../../../../../../utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../utils/labels/labelUtilty';
import CouponCardLabels, { ACCOUNT_LABELS, CHECKOUT_LABELS } from '../../labels/CouponCard.labels';

function CouponHeader(props) {
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, CouponCardLabels);
  const accountLabel = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, CouponCardLabels);

  const { bagPage } = checkoutLabels;
  const { accountOverview } = accountLabel;
  const { coupon, className, isWallet } = props;
  const isPlacePerksCoupon = () => {
    return (
      coupon.offerType === COUPON_REDEMPTION_TYPE.PLACEPERKS ||
      coupon.offerType === COUPON_REDEMPTION_TYPE.BONUSPOINTDAY ||
      coupon.offerType === COUPON_REDEMPTION_TYPE.BENEFITS
    );
  };

  const renderRightHeaderPlaceCash = () => {
    const [
      isTextMatched,
      firstDollarSymbol,
      firstDollarText,
      offText,
      secondDollarSymbol,
      secondDollarText,
    ] = coupon.title.match(/(\$)(\d+)(\s[A-Za-z]+\s)(\$)(\d+)/) || [];

    return isTextMatched ? (
      <>
        <div className="rightHeaderPlaceCash">
          <BodyCopy
            component="div"
            fontWeight="bold"
            fontSize={isWallet && !isMobileWeb() ? 'fs22' : 'fs20'}
            fontFamily="secondary"
            className="rightHeaderPlaceCashTopText"
          >
            <BodyCopy component="sup" fontWeight="bold" fontSize="fs16" fontFamily="secondary">
              {firstDollarSymbol}
            </BodyCopy>
            <BodyCopy component="span" fontWeight="bold" fontFamily="secondary">
              {firstDollarText}
            </BodyCopy>
            <BodyCopy component="span" fontWeight="bold" fontFamily="secondary">
              {offText}
            </BodyCopy>
            <BodyCopy component="sup" fontWeight="bold" fontSize="fs16" fontFamily="secondary">
              {secondDollarSymbol}
            </BodyCopy>
            <BodyCopy component="span" fontWeight="bold" fontFamily="secondary">
              {secondDollarText}
            </BodyCopy>
          </BodyCopy>
        </div>
      </>
    ) : null;
  };

  const renderRightHeaderRewards = () => {
    return (
      <>
        <BodyCopy component="sup" fontWeight="bold" fontSize="fs20" fontFamily="secondary">
          {coupon?.title?.replace(/[^$]/g, '')}
        </BodyCopy>
        {coupon?.title?.replace(/[^0-9]/g, '')}
        <BodyCopy component="sup" fontWeight="bold" fontSize="fs20" fontFamily="secondary">
          {coupon?.title?.replace(/[^%]/g, '')}
        </BodyCopy>
      </>
    );
  };

  const renderHeaderImage = (imageName) => {
    const { spcBag, spc, isCartPageCouponSection } = props;
    return (
      <div className="rightHeaderPlacePerks">
        <div className="place-perks-image-container">
          <Image
            alt={imageName}
            src={getIconPath(imageName)}
            width={
              coupon.offerType === COUPON_REDEMPTION_TYPE.SAVING &&
              !(spc || spcBag || isCartPageCouponSection)
                ? 42
                : 34
            }
          />
        </div>
      </div>
    );
  };

  const renderRightHeaderPlacePerks = () => {
    const couponTitle = coupon?.title?.toLowerCase();
    const [isShipTextMatched] = couponTitle?.match(/ship/) || [];
    const [isGiftTextMatched] = couponTitle?.match(/gift/) || [];
    const [isBonusTextMatched] = couponTitle?.match(/bonus/) || [];

    if (isBonusTextMatched) {
      return renderHeaderImage('place-perks-double-point-day');
    }
    if (isShipTextMatched) {
      return renderHeaderImage('place-perks-shipping');
    }

    if (isGiftTextMatched) {
      return renderHeaderImage('place-perks-free-delux-gift-reward');
    }

    return (
      <>
        <BodyCopy component="sup" fontWeight="bold" fontSize="fs20" fontFamily="secondary">
          {coupon?.title?.replace(/[^$]/g, '')}
        </BodyCopy>
        {coupon?.title?.replace(/[^0-9]/g, '')}
        <BodyCopy component="sup" fontWeight="bold" fontSize="fs20" fontFamily="secondary">
          {coupon?.title?.replace(/[^%]/g, '')}
        </BodyCopy>
      </>
    );
  };

  const renderRightHeaderSavings = () => {
    return renderHeaderImage('savings-offer-icon');
  };

  const renderPlacePerksTitle = () => {
    const couponTitle = coupon?.title?.toLowerCase();
    const [isShipTextMatched] = couponTitle?.match(/ship/) || [];
    const [isGiftTextMatched] = couponTitle?.match(/gift/) || [];
    const [isBonusTextMatched] = couponTitle?.match(/bonus/) || [];

    if (isBonusTextMatched || isShipTextMatched || isGiftTextMatched) {
      return renderLabel(bagPage?.lbl_coupon_offerText, 'lbl_coupon_offerText');
    }

    return renderLabel(
      accountOverview?.lbl_overview_couponTypeReward,
      'lbl_overview_couponTypeReward'
    );
  };

  const getCouponStatusClasses = (spc, spcBag) => {
    return coupon.status === 'applied' && !spc && !spcBag
      ? 'rounded-corner'
      : 'semi-rounded-stripe';
  };

  const coupRightHeaderCheck = () => {
    const { isAccountDrawer, isAccountDashboard, isPlacePerkEnabled, isPlacePerks } = props;

    return isAccountDrawer || isAccountDashboard || (isPlacePerkEnabled && isPlacePerks);
  };

  const isBenefits = () => coupon.offerType === COUPON_REDEMPTION_TYPE.BENEFITS;

  const getCurrentPerkLevelName = () => {
    const showCurrentPerkLevel =
      coupon?.perkLevel?.toLowerCase() === 'plccmegastar'
        ? 'MEGASTAR'
        : coupon?.perkLevel?.toUpperCase() || '';

    const currentPerkBonuPointDayLevelName =
      props.currentPerkLevel?.toLowerCase() === 'plccmegastar'
        ? 'MEGASTAR'
        : props.currentPerkLevel?.toUpperCase();

    return coupon?.perkLevel?.toUpperCase() === 'BONUSPOINTDAY'
      ? currentPerkBonuPointDayLevelName
      : showCurrentPerkLevel;
  };

  const renderPlacePerksContent = (currentPerkLevelName) => {
    return isBenefits() ? (
      renderLabel(bagPage?.lbl_benefits_coupon_heading, 'lbl_benefits_coupon_heading')
    ) : (
      <>
        <div className={`place-perks-star-header ${currentPerkLevelName?.toLowerCase()}`}>
          <Image alt="place-perks-small-star" src={getIconPath('place-perks-small-star')} />
        </div>
        {`${coupon?.perkLevel ? currentPerkLevelName : ''} ${renderPlacePerksTitle()}`}
      </>
    );
  };

  const renderRightHeaderContent = () => {
    return (
      <>
        {coupon.offerType === COUPON_REDEMPTION_TYPE.SAVING && renderRightHeaderSavings()}
        {coupon.offerType === COUPON_REDEMPTION_TYPE.REWARDS && renderRightHeaderRewards()}
        {coupon.offerType === COUPON_REDEMPTION_TYPE.PLACECASH && renderRightHeaderPlaceCash()}
        {isPlacePerksCoupon() && renderRightHeaderPlacePerks()}
      </>
    );
  };

  const RenderCardHeader = (type, headingClass, dataLocator) => {
    const { spcBag, spc } = props;
    const currentPerkLevelName = getCurrentPerkLevelName();

    return (
      <div className="couponCard__header">
        <div className={`alignItem ${headingClass} ${getCouponStatusClasses(spc, spcBag)}`}>
          {isPlacePerksCoupon() ? (
            <BodyCopy
              data-locator={dataLocator}
              className={`${
                isBenefits()
                  ? 'couponCard__header_text'
                  : 'couponCard__header_text place-perks-star-coupon-container'
              }`}
              component="p"
              fontSize="fs10"
              fontFamily="secondary"
            >
              {renderPlacePerksContent(currentPerkLevelName)}
            </BodyCopy>
          ) : (
            <BodyCopy
              data-locator={dataLocator}
              className="couponCard__header_text"
              component="p"
              fontSize="fs10"
              fontFamily="secondary"
            >
              {type}
            </BodyCopy>
          )}
          {coupRightHeaderCheck() && (
            <BodyCopy
              component="p"
              fontWeight="bold"
              fontSize="fs36"
              fontFamily="secondary"
              className={
                coupon.offerType === COUPON_REDEMPTION_TYPE.PLACECASH ||
                coupon.offerType === COUPON_REDEMPTION_TYPE.SAVING
                  ? 'elem-mr-SM'
                  : 'elem-mr-MED'
              }
            >
              {renderRightHeaderContent()}
            </BodyCopy>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={className}>
      {coupon.offerType === COUPON_REDEMPTION_TYPE.SAVING &&
        RenderCardHeader(
          renderLabel(bagPage?.lbl_couponlist_savings, 'lbl_couponlist_savings'),
          'couponCard__header_saving',
          `${coupon.status}_PublicValidityLbl`
        )}
      {coupon.offerType === COUPON_REDEMPTION_TYPE.REWARDS &&
        RenderCardHeader(
          renderLabel(bagPage?.lbl_couponlist_rewards, 'lbl_couponlist_rewards'),
          'couponCard__header_rewards',
          `${coupon.status}_rewardValidityLbl`
        )}
      {coupon.offerType === COUPON_REDEMPTION_TYPE.PLACECASH &&
        RenderCardHeader(
          renderLabel(bagPage?.lbl_couponlist_placeCash, 'lbl_couponlist_placeCash'),
          'couponCard__header_pc',
          `${coupon.status}_PlaceCashValidityLbl`
        )}
      {isPlacePerksCoupon() &&
        RenderCardHeader(
          COUPON_REDEMPTION_TYPE.PLACEPERKS,
          'couponCard__header_placeperks',
          `${coupon.status}_PlacePerksValidityLbl`
        )}
    </div>
  );
}

CouponHeader.propTypes = {
  coupon: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  isCarouselView: PropTypes.bool.isRequired,
  commonLabels: PropTypes.shape({}).isRequired,
};

export default withStyles(CouponHeader, styles);
export { CouponHeader as CouponHeaderVanilla };
